export const downloadUrl = (file, fileName) => {
  let url;
  if (typeof file === "string") {
    url = file;
  } else {
    url = URL.createObjectURL(file);
  }

  const linkEl = document.createElement("a");
  linkEl.download = fileName;
  linkEl.href = url;
  linkEl.target = "_blank";

  document.body.appendChild(linkEl);
  linkEl.click();

  document.body.removeChild(linkEl);
};
